import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';
import moment from 'moment';

const HEADER_COLOR = [75, 75, 156];
const ALT_ROW_COLOR = [240, 240, 250];
const MARGIN = { left: 7, right: 7 };

function fmtDate(d) {
  return d ? moment(d).format('YYYY-MM-DD') : '';
}

function addPageFooter(doc, generatedAt, filterLabel) {
  const total = doc.internal.getNumberOfPages();
  const w = doc.internal.pageSize.getWidth();
  const h = doc.internal.pageSize.getHeight();
  doc.setFontSize(7.5);
  doc.setFont('helvetica', 'normal');
  for (let i = 1; i <= total; i++) {
    doc.setPage(i);
    doc.text(`Page ${i} of ${total}`, 14, h - 5);
    doc.text(`Report produced by PNG Time Access for "${filterLabel}"`, w / 2, h - 5, { align: 'center' });
    doc.text(generatedAt, w - 14, h - 5, { align: 'right' });
  }
}

// ── Details Report ───────────────────────────────────────────────────────────
export function generateDetailsReport(rows, adminDesc, filterLabel = adminDesc) {
  const generatedAt = moment().format('DD/MM/YYYY HH:mm:ss');
  const doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'a4' });

  doc.setFontSize(11);
  doc.setFont('helvetica', 'bold');
  doc.text(`Agency Name: ${adminDesc}   Staff Establishment Details`, 14, 13);

  autoTable(doc, {
    startY: 19,
    margin: MARGIN,
    styles: { fontSize: 6.5, cellPadding: 1.5, overflow: 'linebreak' },
    headStyles: { fillColor: HEADER_COLOR, textColor: 255, fontStyle: 'bold' },
    alternateRowStyles: { fillColor: ALT_ROW_COLOR },
    head: [[
      'No', 'Employee No', 'Name Report', 'Occup Pos Title',
      'Position Status', 'Gender', 'Date of Birth', 'Age',
      'Employee Email ID', 'Phone Number', 'Mobile Number',
      'Employee Portal Login Status',
    ]],
    body: rows.map((emp, i) => [
      i + 1,
      emp.employee_no ?? '',
      emp.name_report ?? '',
      emp.occup_pos_title ?? '',
      emp.position_attached !== false ? 'Attached' : 'Unattached',
      emp.gender ?? '',
      fmtDate(emp.date_of_birth),
      emp.age ?? '',
      emp.email ?? '',
      emp.phone_number ?? '',
      emp.mobile_number ?? '',
      emp.status !== false ? 'Active' : 'Inactive',
    ]),
  });

  addPageFooter(doc, generatedAt, filterLabel);
  doc.save(`Staff_Details_Report_${adminDesc}.pdf`);
}

// ── Shared helper for Attached / Unattached ──────────────────────────────────
function generatePositionReport(rows, adminDesc, subtitle, filename, generatedAt, filterLabel) {
  const doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'a4' });

  doc.setFontSize(11);
  doc.setFont('helvetica', 'bold');
  doc.text(`Agency Name: ${adminDesc}`, 14, 12);
  doc.text(subtitle, 14, 20);

  autoTable(doc, {
    startY: 26,
    margin: MARGIN,
    styles: { fontSize: 7, cellPadding: 1.5, overflow: 'linebreak' },
    headStyles: { fillColor: HEADER_COLOR, textColor: 255, fontStyle: 'bold' },
    alternateRowStyles: { fillColor: ALT_ROW_COLOR },
    head: [[
      'No', 'Employee No', 'Name Report', 'Occup Pos Title',
      'Gender', 'Date of Birth', 'Age',
      'Employee Email ID', 'Phone Number', 'Mobile Number',
      'Employee Portal Login Status',
    ]],
    body: rows.map((emp, i) => [
      i + 1,
      emp.employee_no ?? '',
      emp.name_report ?? '',
      emp.occup_pos_title ?? '',
      emp.gender ?? '',
      fmtDate(emp.date_of_birth),
      emp.age ?? '',
      emp.email ?? '',
      emp.phone_number ?? '',
      emp.mobile_number ?? '',
      emp.status !== false ? 'Active' : 'Inactive',
    ]),
  });

  addPageFooter(doc, generatedAt, filterLabel);
  doc.save(filename);
}

// ── Attached Report ──────────────────────────────────────────────────────────
export function generateAttachedReport(rows, adminDesc, filterLabel = adminDesc) {
  const generatedAt = moment().format('DD/MM/YYYY HH:mm:ss');
  const filtered = rows.filter((e) => e.position_attached !== false);
  generatePositionReport(
    filtered, adminDesc,
    'Attached Positions Report',
    `Attached_Report_${adminDesc}.pdf`,
    generatedAt, filterLabel,
  );
}

// ── Unattached Report ────────────────────────────────────────────────────────
export function generateUnattachedReport(rows, adminDesc, filterLabel = adminDesc) {
  const generatedAt = moment().format('DD/MM/YYYY HH:mm:ss');
  const filtered = rows.filter((e) => e.position_attached === false);
  generatePositionReport(
    filtered, adminDesc,
    'Unattached Positions Report',
    `Unattached_Report_${adminDesc}.pdf`,
    generatedAt, filterLabel,
  );
}
